/* eslint-disable no-undef */
// userSaga.js
import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { CHECK_SCHEDULE_REQUEST, REQUEST_BLOG, REQUEST_DOCTOR_SEARCH } from './Constants';
import { blogListErrorRequest, blogListSuccessRequest, checkScheduleErrorRequest, checkScheduleSuccessRequest, doctorListErrorRequest, doctorListPagination, doctorListSuccessRequest } from './Actions';
// import logo from '../../Images/logo.png';

function* getDoctorList(action) {

    try {

        const url1 = `${process.env.REACT_APP_API_BASE_URL}/searchcount`;

        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        let departmentSpec;
        if (action.payload.spec) {
            departmentSpec = JSON.stringify([Number(action.payload.spec)]);
        } else {
            departmentSpec = JSON.stringify([]);
        }
        
        let consultationType;
        if (action.payload.consult) {
            consultationType = JSON.stringify((action.payload.consult));
        } else {
            consultationType = JSON.stringify([]);
        }
        // const data = {'city':'','name':'','location':'','startdate':'2025-03-28','enddate':'2025-05-07','consult':'[1,3,2,4]','rating':'','gender':'','orgfeelow':0,'spec':'[]','orgfeehigh':5000};  // Data you want to send with the POST request (can be empty for a simple POST)
        const data = {
            city: '',
            name: action.payload.name,
            location: action.payload.location,
            startdate: action.payload.startdate,
            enddate: action.payload.enddate,
            consult: consultationType,
            rating: '',
            gender: action.payload.gender,
            orgfeelow:action.payload.orgfeelow,
            spec: departmentSpec,
            orgfeehigh: action.payload.orgfeehigh,
            page: action.payload.page
        };


        const response1 = yield call(axios.post, url1, data, { headers });

        // // Check if the response is successful
        if (response1.status === 200 || response1.status === 201) {

            let pageNo = action.payload.page;

            if (pageNo == null) {
                pageNo = 1;
            }

            const skip = (pageNo - 1) * 4;

            const url2 = `${process.env.REACT_APP_API_BASE_URL}/search?limit=4&skip=${skip}`;


            const response2 = yield call(axios.post, url2, data, { headers });

            if (response2.status == 200 || response2.status == 201) {

                yield put(doctorListPagination(response1.data));
                yield put(doctorListSuccessRequest(response2.data));

            } else {
                yield put(doctorListErrorRequest('An error occurred.'));
            }

        } else {
            yield put(doctorListErrorRequest('An error occurred.'));

        }

    } catch (error) {
        yield put(doctorListErrorRequest('An error occurred.'));
    }
}


function* blogdetails() {

    try {
        let url = `${process.env.REACT_APP_API_BASE_URL}/blog?organisationsId=140&$limit=10`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        const response = yield call(axios.get, url,{ headers});
        if (response.status === 200 || response.status === 201) {            
            yield put(blogListSuccessRequest(response.data));
        }
    } catch (error) {
    // throw error;
        yield put(blogListErrorRequest(error));
    }

}


function* consultationSlots(action) {

    try {

        let url = `${process.env.REACT_APP_API_BASE_URL}/schedules?doctorsId=${action.payload.doctorsId}&consultationTypeId=3&date[$gte]=${action.payload.startDate}&date[$lte]=${action.payload.endDate}&isVacant=true`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        const response = yield call(axios.get, url,{ headers});
        if (response.status === 200 || response.status === 201) {    
                    
            yield put(checkScheduleSuccessRequest(response.data));
        }
    } catch (error) {
    // throw error;
        yield put(checkScheduleErrorRequest(error));
    }

}

// Watcher Saga
export function* watchFetchDoctorListing() {
    yield takeEvery(REQUEST_DOCTOR_SEARCH, getDoctorList);
    yield takeEvery(REQUEST_BLOG, blogdetails);
    yield takeEvery(CHECK_SCHEDULE_REQUEST, consultationSlots);

}
